import { gql } from '@apollo/client';

export const downloadPolicy = gql`
  mutation downloadPolicy($id: String!) {
    production {
      downloadPolicy(id: $id) {
        content
        contentType
        fileName
      }
    }
  }
`;


